import { ReferrerProvider, retry } from '@color/lib';
import { lazy } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { CompatRouter } from 'react-router-dom-v5-compat';

import { ParticipantProvider } from 'ui/Account/Participant/context';

import { AppPageErrorBoundary } from '../ErrorBoundaries/AppPageErrorBoundary';
import { AppProviders } from '../Providers';

const AppPortals = lazy(() => retry(() => import('../components/AppPortals')));

export const App = () => {
  return (
    <AppProviders>
      <BrowserRouter>
        <CompatRouter>
          <ParticipantProvider>
            <AppPageErrorBoundary>
              <ReferrerProvider>
                <AppPortals />
              </ReferrerProvider>
            </AppPageErrorBoundary>
          </ParticipantProvider>
        </CompatRouter>
      </BrowserRouter>
    </AppProviders>
  );
};
